import React from "react";
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import StickyTable from "../../shared/StickyTable";
import {
  PatriotSearchApiResponse,
  PatriotSearchAkaResult,
  PatriotSearchIndividualResult,
  PatriotSearchResultValue
} from "./types";

interface IProps {
  response: PatriotSearchApiResponse;
}

function getResponseValue(response: PatriotSearchApiResponse): PatriotSearchResultValue {
  return response.value ?? response.Value ?? {};
}

function getResults(response: PatriotSearchApiResponse): PatriotSearchIndividualResult[] {
  const value = getResponseValue(response);
  return value.results ?? value.Results ?? [];
}

function getTotalCount(response: PatriotSearchApiResponse): number {
  const value = getResponseValue(response);
  return value.totalCount ?? value.TotalCount ?? getResults(response).length;
}

function getAkaName(aka: PatriotSearchAkaResult): string {
  return aka.akaName ?? aka.AkaName ?? "";
}

function getAkaResults(result: PatriotSearchIndividualResult): PatriotSearchAkaResult[] {
  return result.akaResults ?? result.AkaResults ?? [];
}

export default function PatriotResultList({ response }: IProps) {
  const results = getResults(response);

  return (
    <>
      <Typography sx={{ mb: 1 }}>Total Count: {getTotalCount(response)}</Typography>
      <TableContainer component={Paper}>
        <StickyTable>
          <TableHead>
            <TableRow>
              <TableCell>Score</TableCell>
              <TableCell>Patriot Name</TableCell>
              <TableCell>Matched Name</TableCell>
              <TableCell>Match Source</TableCell>
              <TableCell>AKA Names</TableCell>
              <TableCell>ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map((row, index) => (
              <TableRow key={row.id ?? row.Id ?? index}>
                <TableCell>{row.score ?? row.Score}</TableCell>
                <TableCell>{row.name ?? row.Name}</TableCell>
                <TableCell>{row.matchedName ?? row.MatchedName}</TableCell>
                <TableCell>{row.matchSource ?? row.MatchSource}</TableCell>
                <TableCell>{getAkaResults(row).map(getAkaName).filter(Boolean).join(", ")}</TableCell>
                <TableCell>{row.id ?? row.Id}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StickyTable>
      </TableContainer>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
        Raw response
      </Typography>
      <Paper sx={{ p: 2, overflow: "auto" }}>
        <pre style={{ margin: 0 }}>{JSON.stringify(response, null, 2)}</pre>
      </Paper>
    </>
  );
}
